
import { PropTypes } from 'prop-types';

const FormLayout = ({children}) => {
    return (
        <div className="flex items-center justify-center p-4 md:p-6 lg:p-8 ">
            <div className="block w-full border rounded-xl mx-2 md:mx-4 lg:max-w-7xl mt-12  bg-white px-6 py-12 md:py-16 md:px-8 ">
            {children}
            </div>
        </div>
    )
}
FormLayout.propTypes = {
    children: PropTypes.node
}
export default FormLayout